export default __webpack_public_path__ + "media/TAW-form.html";